import i18n from "../i18n";

export const getScoreText = (totalAnswersRight) => {
	let scoreText;
    if (totalAnswersRight < 2) {
        scoreText = "bad_score";
    }
    else if (totalAnswersRight < 5) {
        scoreText = "good_score";
    }
    else if (totalAnswersRight < 9) {
        scoreText = "neat_score";
    }
    else {
        scoreText = "wonderful_score";
    }

    return `${i18n.t(scoreText)} ${i18n.t("score_point_text")}`;
}

export const getScoreVideoName = (totalAnswersRight) => {
	let scoreVideoName;
    if (totalAnswersRight < 2) {
        scoreVideoName = "/result_0.mp4";
    }
    else if (totalAnswersRight < 5) {
        scoreVideoName = "/result_1.mp4";
    }
    else if (totalAnswersRight < 9) {
        scoreVideoName = "/result_2.mp4";
    }
    else {
        scoreVideoName = "/result_3.mp4";
    }
    return scoreVideoName;
}